<template>
  <section class="ai-case-page" :aria-label="title">
    <header class="ai-case-page-heading"><h2>{{ title }}</h2><button class="btn small" type="button" :disabled="busy" @click="$emit('close')">返回</button></header>
    <div class="ai-case-page-content"><slot /></div>
    <footer class="ai-case-page-footer"><slot name="footer" /></footer>
  </section>
</template>
<script>
export default { name: 'AiCasePageLayout', props: { title: String, busy: Boolean } }
</script>
